import React from 'react';
import { Link } from 'react-router-dom';

const ReferralProgram: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero */}
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
            Referral & Affiliate Program
          </h1>
          <p className="mt-3 text-base sm:text-lg text-gray-600">
            Whether you're an individual creator or run a design platform, you can join our program,
            share custom gift deals, and earn commissions.
          </p>
        </div>

        {/* How it Works */}
        <div className="bg-white rounded-lg shadow p-6 sm:p-8 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">How It Works</h2>
          <ol className="list-decimal pl-6 space-y-3 text-gray-700">
            <li>
              Sign up for an account on our site. In your account center, navigate to
              <span className="font-medium"> Referrals</span> and create a coupon.
            </li>
            <li>
              Share the coupon with your audience. Platform owners can embed the coupon as a link on
              their site. When customers arrive via your link, they receive the discount you set.
            </li>
            <li>
              You earn a commission based on eligible orders placed with your coupon or referral link.
            </li>
          </ol>
        </div>

        {/* Commission & Discounts */}
        <div className="bg-white rounded-lg shadow p-6 sm:p-8 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Discounts & Commission</h2>
          <ul className="space-y-3 text-gray-700">
            <li>
              Different product categories may have different commission baselines.
            </li>
            <li>
              Long-term, high-quality partners may receive higher baseline commission rates.
            </li>
            <li>
              The higher the discount you grant to customers, the lower your commission on those
              orders. Conversely, sustainable collaborations over time increase your total earnings.
            </li>
            <li>
              All earnings are transparently itemized in your account, and we will also send periodic
              summary emails.
            </li>
          </ul>
        </div>

        {/* Transparency */}
        <div className="bg-white rounded-lg shadow p-6 sm:p-8 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Tracking & Payouts</h2>
          <p className="text-gray-700">
            Your referral performance and earnings are clearly displayed in your account dashboard. We
            regularly reconcile commissions and notify you by email. If any questions arise, our team is
            here to help.
          </p>
        </div>

        {/* Call to Action */}
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h3 className="text-lg font-semibold text-blue-900">Have questions?</h3>
            <p className="text-blue-800/90">
              Visit our contact page and we'll be happy to assist you.
            </p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReferralProgram;


